import { region, apiUrl } from "../Configs";

const REGION_LANGUAGE_MAP = {
  BR: "pt-BR",
  CA: "en-CA",
};

export const FALLBACK_LANGUAGE = "pt-BR";

const LANGUAGE_ENDPOINT = "/v1/language";
const STORAGE_LANGUAGE_KEY = "language";
const STORAGE_LANGUAGE_ID_KEY = "languageId";

const isBrowser = typeof window !== "undefined" && typeof window.localStorage !== "undefined";
let cachedLanguages = null;

function getStorage() {
  return isBrowser ? window.localStorage ?? null : null;
}

export function getDefaultLanguageByRegion(currentRegion = region) {
  const normalizedRegion = (currentRegion || "").toUpperCase();
  return REGION_LANGUAGE_MAP[normalizedRegion] || FALLBACK_LANGUAGE;
}

export function ensureLanguageStored() {
  const storage = getStorage();
  if (!storage) {
    return getDefaultLanguageByRegion();
  }

  const storedLanguage = storage.getItem(STORAGE_LANGUAGE_KEY);
  if (storedLanguage) {
    return storedLanguage;
  }

  const defaultLanguage = getDefaultLanguageByRegion();
  storage.setItem(STORAGE_LANGUAGE_KEY, defaultLanguage);
  return defaultLanguage;
}

function getNormalizedApiUrl() {
  if (!apiUrl) {
    return null;
  }
  return apiUrl.endsWith("/") ? apiUrl.slice(0, -1) : apiUrl;
}

async function fetchLanguages() {
  if (cachedLanguages) {
    return cachedLanguages;
  }

  const baseUrl = getNormalizedApiUrl();
  if (!baseUrl) {
    return [];
  }

  try {
    const response = await fetch(`${baseUrl}${LANGUAGE_ENDPOINT}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch languages: ${response.status}`);
    }

    const data = await response.json();
    cachedLanguages = Array.isArray(data) ? data : [];
    return cachedLanguages;
  } catch (error) {
    console.error("Failed to load language list", error);
    return [];
  }
}

export async function ensureLanguagePreferencesReady() {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  const language = ensureLanguageStored();
  const storedLanguageId = storage.getItem(STORAGE_LANGUAGE_ID_KEY);
  if (storedLanguageId) {
    return;
  }

  const languages = await fetchLanguages();
  const match = languages.find((lang) => lang.code === language);
  if (match?.id) {
    storage.setItem(STORAGE_LANGUAGE_ID_KEY, match.id);
  }
}
